module.exports = __webpack_public_path__ + "static/media/GWS_Giants_logo.7265cc55.svg";